module.exports = __webpack_public_path__ + "static/img/logo_ddc.dce6a6b8.svg";